import QueryString from 'qs'

export function parseQueryString<T>(): T {
  const queryString = window.location.search.substring(1)
  return QueryString.parse(queryString) as unknown as T
}
